"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.availableScopes = exports.availableScopeGroups = void 0;
exports.availableScopeGroups = {
    admin: [
        { scopes: ['read:creditors', 'write:creditors'] },
        { scopes: ['read:users', 'write:users'] },
        { scopes: ['read:cases', 'write:cases'] },
        { scopes: ['read:customers', 'write:customers'] },
        { scopes: ['read:case-vouchers', 'write:case-vouchers'] },
        { scopes: ['write:files'] },
        { scopes: ['read:links'] },
        { scopes: ['read:updates', 'write:updates'] },
        { scopes: ['write:collection-engine.vouchers'] },
        {
            scopes: [
                'read:insights.cases',
                'read:insights.creditors',
                'read:insights.satisfactions',
                'read:insights.debtor-vouchers',
                'read:insights.case-vouchers',
                'read:insights.billing-vouchers',
                'read:insights.users',
                'read:insights.updates',
                'read:insights.update-types',
                'read:insights.workflows',
                'read:insights.workflow-tasks',
                'read:insights.case-statuses',
                'read:insights.interactions',
                'read:insights.documents',
                'read:insights.payment-plans',
                'read:insights.payment-plan-entries',
                'read:insights.customers',
                'read:insights.users-on-customers',
                'read:insights.properties',
            ],
        },
    ],
    client: [
        {
            scopes: ['read:cases', 'write:cases'],
        },
        {
            scopes: ['write:files'],
        },
        {
            scopes: ['read:links'],
        },
        {
            scopes: ['read:customers', 'write:customers'],
        },
        {
            scopes: ['write:interactions.create'],
        },
        {
            scopes: ['read:case-vouchers', 'write:case-vouchers'],
        },
        {
            scopes: ['read:insights.cases'],
        },
    ],
};
exports.availableScopes = Object.entries(exports.availableScopeGroups).reduce((acc, [role, groups]) => {
    acc[role] = groups.reduce((azz, group) => [...azz, ...group.scopes], []);
    return acc;
}, {});
//# sourceMappingURL=index.js.map